var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef273f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db1c33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f22a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e51d34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fadf46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dc38"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.00018118 4.79323175-8.73283956-5.89037465-.85210346 1.26329535 8.22243508 5.5461025-8.22243508 5.54610245.85210346 1.2632954 8.73283956-5.89037466 8.73283952 5.89037466.8521035-1.2632954-8.22243513-5.54610245 8.22243513-5.5461025-.8521035-1.26329535z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85732402 1.90630024c0-.21236535.16438294-.38452148.37743923-.38452148h1.53083584c.20845394 0 .37743923.16307431.37743923.38452148v.75476656c0 .21236534-.12230575.50682721-.26506697.64958845l-.6127232.61272321c-.14639245.14639244-.38737272.14276123-.53013394 0l-.61272322-.61272321c-.14639245-.14639245-.26506697-.42814128-.26506697-.64958845z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.00018118 3.04558828c-.21039421 0-.38095238-.17055819-.38095238-.38095238s.17055817-.38095238.38095238-.38095238.38095238.17055819.38095238.38095238-.17055817.38095238-.38095238.38095238zm0-1.52380952c-.63118258 0-1.14285716-.1705582-1.14285716-.38095238 0-.2103942.51167458-.38095239 1.14285716-.38095239.63118255 0 1.14285714.17055819 1.14285714.38095239 0 .21039418-.51167459.38095238-1.14285714.38095238z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJe);
export default __webpack_public_path__ + "static/media/JE.6a0bd82fc1d4c4bf52318c853e3e5562.svg";
export { ForwardRef as ReactComponent };